export const userSessionConstants = {
    idleTimeLimit: 600
};
